<template>
  <b-form @submit.prevent="onSubmit">
    <b-card-header
        v-if="isHeaderVisible"
        class="v3_box_teal_header v3_color_black_knight"
    >
      <b-row>
        <b-col sm="12" md="6" class="align-self-center text-center-mobile">
          <span class="v3_color_teal text-uppercase font_weight_bold text-sm-center">
            {{ user.email }}
          </span>
        </b-col>
        <b-col
            sm="12"
            md="6"
            class="d-flex align-items-center justify-content-end mobile-buttons-profile"
        >
          <b-button type="submit" variant="v3_teal_outline">
            <template v-if="!saveLoading">Save</template>
            <template v-else>
              <b-spinner small/>
              <span class="ml-1">Saving...</span>
            </template>
          </b-button>
          <b-button variant="v3_teal_outline" class="ml-3" @click="cancel">
            Cancel
          </b-button>
        </b-col>
      </b-row>
    </b-card-header>
    <b-card-body class="v3_box_teal_body p-4 p-sm-2">
      <div class="grey-box">
        <div class="border_1 border_grey p-3">
          <recruiter-form
          :initial-data="user"
          ref="recruiterForm">
          </recruiter-form>
        </div>
      </div>
    </b-card-body>
  </b-form>
</template>

<script>
import RecruiterForm from "@/components/recruiter/form/RecruiterForm";
import Api from '@/providers/Api';

export default {
  name: 'UserProfileRecruiterForm',
  components: {
    RecruiterForm,
  },
  props: {
    saveLoading: {
      type: Boolean,
      default: false,
    },
    isHeaderVisible: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    user: function () {
      return this.$store.state.user ? this.$store.state.user : {};
    },
  },
  methods: {
    cancel: function () {
      this.$emit('profileFormCancel');
    },
    onSubmit: async function () {
      const userData = this.$refs.recruiterForm.getData();
      const { user, profile } = await Api.updateRecruiterProfile(userData);
      
      this.userData = {
        ...user,
        ...profile,
      };
      console.log(userData);
      // this.$v.$touch();
      // if (this.$v.$anyError) {
      //   this.$emit('validate-failed');
      //   return;
      // }

      // let updatedUser = {
      //   ...this.user,
      //   ethnicity: this.ethnicity,
      //   gender_identity: this.genderIdentity,
      //   visa_status: this.visaStatus,
      //   is_us_veteran: this.isUSVeteran,
      // };
      // if (this.isFieldSupported('specialty')) {
      //   updatedUser.specialty_id = this.specialtyId;
      // }
      // if (this.isFieldSupported('subspecialty')) {
      //   updatedUser.subspecialty_id = this.subspecialtyId;
      // }
      // if (this.isFieldSupported('boardCertifications')) {
      //   updatedUser.has_board_certification = this.hasBoardCertification;
      //   updatedUser.boardCertifications = this.boardCertifications;
      // }
      // if (this.isFieldSupported('npi')) {
      //   updatedUser.npi = this.npi;
      // }
      // if (this.isFieldSupported('practice_zip')) {
      //   updatedUser.practice_zip = this.zip || null;
      // }

      this.$emit('profileFormSubmit', userData);
    },
  },
};
</script>

<style scoped>
@media (max-width: 768px) {
  .text-center-mobile {
    text-align: center;
    margin-bottom: 0.75rem;
  }

  .grey-box {
    padding: 1rem !important;
  } 

  .p-sm-2 {
    padding: 0.75rem !important;
  }

  .phairify-select-wrapper {
    min-width: unset !important;
  }

  .mobile-buttons-profile {
    justify-content: center !important;
  }
}
</style>

<style lang="scss" scoped>
@import '../../../../../sass/v3';

.phairify-select-wrapper {
  min-width: 215px;
  width: 100%;

  &:after {
    font-size: 22px;
    right: 10px;
  }

  .custom-select {
    height: 100%;
    padding: 15px;
  }
}

.invalid-feedback {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #dc3545;
  display: block;
}

// .grey-box {
//   border: none;
//   border-radius: 0;
//   background-color: rgba($v3_color_black_knight, 0.025);
//   padding: 1rem;
// }
</style>
